<app-shared-page-loading
  *ngIf="(isLoading$ | async); else weeeContainer"
></app-shared-page-loading>

<ng-template #weeeContainer>
  <div class="weee-container" fxLayout="row" fxLayoutAlign="center center">
    <div class="weee" fxLayout="column" fxLayoutAlign="center center">
      <mm-icon class="weee__icon"
               [ngClass]="{'error' : (status=== WEEE_STATUS.ErrorExpired || status===WEEE_STATUS.ErrorNotFound)}"
               name="{{status === WEEE_STATUS.Accept || status === WEEE_STATUS.Reject ? 'check-mark-small': 'block'}}">
      </mm-icon>
      <div [ngSwitch]="status">
        <div *ngSwitchCase="WEEE_STATUS.Accept">
          <p class="weee__title">
            {{ 'WEEE.FEEDBACK.TITLE.SUCCESS.YES' | translate }}
          </p>
          <p class="weee__message">
            {{ 'WEEE.FEEDBACK.BODY.SUCCESS.YES' | translate }}
          </p>
        </div>
        <div *ngSwitchCase="WEEE_STATUS.Reject">
          <p class="weee__title">
            {{ 'WEEE.FEEDBACK.TITLE.SUCCESS.NO' | translate }}
          </p>
          <p class="weee__message">
            {{ 'WEEE.FEEDBACK.BODY.SUCCESS.NO' | translate }}
          </p>
        </div>
        <div *ngSwitchCase="WEEE_STATUS.ErrorExpired">
          <p class="weee__title">
            {{ 'WEEE.FEEDBACK.TITLE.EXPIRED' | translate }}
          </p>
          <p class="weee__message">
            {{ 'WEEE.FEEDBACK.BODY.EXPIRED' | translate }}
          </p>
        </div>
        <div *ngSwitchCase="WEEE_STATUS.ErrorNotFound">
          <p class="weee__title">
            {{ 'WEEE.FEEDBACK.TITLE.ERROR' | translate }}
          </p>
          <p class="weee__message">
            {{ 'WEEE.FEEDBACK.BODY.ERROR' | translate }}
          </p>
        </div>
      </div>

      <a [href]="FRESHDESK_URL_DE" target="_blank">
        <button
          mm-button
          class="weee__action"
          color="primary"
          size="large"
          *ngIf="status===WEEE_STATUS.ErrorNotFound"
        >
          {{ 'ERROR.403_PAGE.BUTTON_LABEL' | translate }}
        </button>
      </a>
    </div>
  </div>
</ng-template>
